export function DashboardPage() {
  return (
    <div className="space-y-6">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Applications" value="12" change="+2 ce mois" />
        <StatCard title="Workflows Actifs" value="28" change="+5 ce mois" />
        <StatCard title="Utilisateurs" value="156" change="+12 ce mois" />
        <StatCard title="Documents Traités" value="1,234" change="+89 ce mois" />
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
          <h2 className="text-lg font-semibold text-secondary-900 dark:text-white">
            Applications Récentes
          </h2>
          <div className="mt-4 space-y-3">
            {['Gestion RH', 'Permis de Construire', 'Réclamations'].map((app) => (
              <div
                key={app}
                className="flex items-center justify-between rounded-lg bg-secondary-50 p-3 dark:bg-secondary-800"
              >
                <span className="text-sm font-medium text-secondary-700 dark:text-secondary-300">
                  {app}
                </span>
                <span className="text-xs text-secondary-500">Actif</span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
          <h2 className="text-lg font-semibold text-secondary-900 dark:text-white">
            Activité Récente
          </h2>
          <div className="mt-4 space-y-3">
            {[
              'Nouveau workflow créé: Approbation Congés',
              'Application mise à jour: Gestion RH',
              'Document traité: Facture #1234',
            ].map((activity, i) => (
              <div
                key={i}
                className="flex items-center gap-3 rounded-lg bg-secondary-50 p-3 dark:bg-secondary-800"
              >
                <div className="h-2 w-2 rounded-full bg-primary-500" />
                <span className="text-sm text-secondary-700 dark:text-secondary-300">
                  {activity}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function StatCard({
  title,
  value,
  change,
}: {
  title: string;
  value: string;
  change: string;
}) {
  return (
    <div className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900">
      <p className="text-sm font-medium text-secondary-500 dark:text-secondary-400">{title}</p>
      <p className="mt-2 text-3xl font-semibold text-secondary-900 dark:text-white">{value}</p>
      <p className="mt-1 text-sm text-green-600 dark:text-green-400">{change}</p>
    </div>
  );
}
